// ponytail: singleton flag + dynamic import to survive Next.js route navigations without re-init and avoid SSR failures
let initialized = false;
let currentGuid: string | null = null;

export const initBraze = async (guid: string): Promise<void> => {
  if (typeof window === "undefined") return;
  if (initialized && currentGuid === guid) return;

  const braze = await import("@braze/web-sdk");
  const apiKey = process.env.NEXT_PUBLIC_BRAZE_API_KEY;

  if (!apiKey) return;

  const baseUrl = "sdk.iad-02.braze.com";

  if (!initialized) {
    braze.initialize(apiKey, { baseUrl });
    initialized = true;
  }

  braze.changeUser(guid);
  braze.openSession();
  // ponytail: content cards off — restore this call and the <BrazeContentCards /> render in PersonalizedFeed to turn them back on
  // braze.requestContentCardsRefresh();
  currentGuid = guid;
};
